import { useCashFundPartnerPlacement } from '@shared/hooks/useCashFundPartnerPlacement/useCashFundPartnerPlacement';
import { CASH_FUNDS_PUBLIC_URL_PATH } from '../Catalog.constants';

export const useActiveCashFundPartnerShop = (): string | null => useCashFundPartnerPlacement('shop').partner;

export const useIsAllyShopPromo = (publicUrlPath: string | undefined): boolean => {
  const partner = useActiveCashFundPartnerShop();
  return partner === 'ally' && publicUrlPath === CASH_FUNDS_PUBLIC_URL_PATH;
};
